@if (imageSlider.length > 0) {
    <div class="carousel-container">
    <button class="carousel-control-prev" [disabled]="imageSlider.length < 2" (click)="carousel.prev()">
            <span class="material-symbols-outlined">chevron_left</span>
        </button>
        <ngb-carousel #carousel [interval]="0" [showNavigationIndicators]="false" [showNavigationArrows]="false">
            @for (slide of imageSlider; track slide; let i = $index) {
                <ng-template ngbSlide>
                    <div class="row">
                        @for (imageUrl of slide; track imageUrl; let j = $index) {
                            <div class="carousel-image-wrapper">
                                <img [src]="imageUrl | secure | async" 
                                    class="carousel-image" 
                                    (click)="openImageModal(imageUrl)"
                                    (load)="onImageLoad(i * imagePerSlide + j)"
                                    (error)="onImageError(i * imagePerSlide + j)"/>
                                <p-skeleton *ngIf="!imageLoaded()[i * imagePerSlide + j]" width="98px" height="55px" />
                            </div>
                        }
                    </div>
                </ng-template>
            }
        </ngb-carousel>
    <button class="carousel-control-next" [disabled]="imageSlider.length < 2" (click)="carousel.next()">
            <span class="material-symbols-outlined">chevron_right</span>
        </button>
    </div>
}
